import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/components/Home.vue";
import BlogList from "@/components/BlogList.vue";
import BlogPost from "@/components/BlogPost.vue";
import { findFighterDesign } from "@/data/fighterDesigns.js";
import { analytics, logEvent } from "../firebase.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/fighters/:fighter",
    name: "Fighter",
    component: Home,
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Home,
  },
  {
    path: "/blog",
    name: "BlogList",
    component: BlogList,
  },
  {
    path: "/blog/:slug",
    name: "BlogPost",
    component: BlogPost,
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  const fighter = to.params.fighter;
  const design = findFighterDesign(fighter);

  if (to.path == "/") {
    next();
  } else if (to.path == "/privacy") {
    next();
  } else if (design != null) {
    next();
  } else if (to.path.startsWith("/blog")) {
    next();
  } else {
    next("/");
  }
});

router.afterEach((to) => {
  const baseTitle = "Origami Skin";

  if (to.path === "/") {
    document.title = `${baseTitle} - Premium Paper Models`;
  } else if (to.path === "/privacy") {
    document.title = `Privacy Policy - ${baseTitle}`;
  } else if (to.name === "Fighter" && to.params.fighter) {
    // Try to get nice name, fallback to param
    const fighter = to.params.fighter;
    const design = findFighterDesign(fighter);
    const name = design ? design.name : fighter.toUpperCase();
    document.title = `${name} - ${baseTitle}`;
  } else {
    document.title = baseTitle;
  }

  logEvent(analytics, 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: to.path
  });
});

export default router;
